import Tooltip from '@mui/material/Tooltip';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import {
  setCustomStyleByUserId,
  setUseCustomStyleByUserId,
} from '@webclient/state/slices/app-settings';
import {
  selectCustomStyle,
  selectUseCustomStyle,
} from '@webclient/state/slices/app-settings/userSettingSelector';

import RefreshRoundedIcon from '~icons/knowz-iconify/refresh-rounded';

import { IconButton, Input, Text } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export default function CustomResponseStyle() {
  const { t } = useTranslate();
  const customStyle = useAppSelector(selectCustomStyle);
  const dispatch = useAppDispatch();
  const userId = useAppSelector((state) => state.auth.me?.uuid);
  const useCustomStyle = useAppSelector(selectUseCustomStyle);
  function handleResponseStyle(responseStyle: string) {
    if (!userId) return;
    dispatch(
      setCustomStyleByUserId({
        userId,
        customStyle: {
          ...customStyle,
          isUpToDate: false,
          responseStyle,
        },
      }),
    );
  }

  function handleResetToDefault() {
    if (!userId) return;
    dispatch(
      setCustomStyleByUserId({
        userId,
        customStyle: {
          isUpToDate: true,
          responseStyle: '',
        },
      }),
    );
    dispatch(setUseCustomStyleByUserId({ userId, useCustomStyle: false }));
  }

  return (
    <>
      <Text
        variant="textSm"
        placehoder={t(
          'layout.main.sections.header.settings.search.customizeResponse.form.placeholder',
          'Respectful, professional & formal.',
        )}
        alignItems="center"
        gap={1}
      >
        {t(
          'layout.main.sections.header.settings.search.customizeResponse.form.title',
          'Customized response style',
        )}
      </Text>

      <Input
        value={customStyle?.responseStyle ?? ''}
        name="responseStyle"
        onChange={(e) => handleResponseStyle(e.target.value)}
        placeholder="Respectful, professional & formal."
        fullWidth
        endAdornment={
          <Tooltip
            title={t(
              'layout.main.sections.header.settings.search.customResponseStyle.resetToDefault',
              'Reset to default',
            )}
            placement="top"
            arrow
          >
            <span>
              <IconButton
                variant="ghost"
                onClick={handleResetToDefault}
                color="secondary"
                disabled={useCustomStyle}
                edge="end"
              >
                <RefreshRoundedIcon width={13} />
              </IconButton>
            </span>
          </Tooltip>
        }
        disabled={!useCustomStyle}
      />

      <Text
        variant="textSm"
        color="grey"
      >
        {t(
          'layout.main.sections.header.settings.search.customizeResponse.form.hint',
          'Edit the response style if you want Knowz to respond differently',
        )}
      </Text>
    </>
  );
}
